import { useFetchCurrentUser } from "@/hooks/api/users"

export function useSupportChatSettings(): { redirectToDocs: boolean; showIntercom: boolean } {
  const { data: user } = useFetchCurrentUser()
  const redirectToDocs = user?.company?.solo_trial === true

  return {
    redirectToDocs,
    showIntercom: !redirectToDocs,
  }
}

export function useShowIntercom(): boolean {
  return useSupportChatSettings().showIntercom
}
